import React, { useState, useMemo } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Container } from "@material-ui/core";
import { push as Menu } from "react-burger-menu";
import cls from "./header.module.scss";
import authentication from "../../redux/actions/authentication";
import HamburgerMenu from "../../components/HamburgerMenu";
import SettingsIcon from "@material-ui/icons/Settings";

const Header = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { user, isAuthorized, role, hasPreorder } = useSelector(state => state.authentication);
  const [localUnp] = useState(localStorage.getItem("unp") || "");
  const [arrayMenu, setArrayMenu] = useState([]);
  const [buttonBurger, setButtonBurger] = useState(false);
  const [styleLeft, setStyleLeft] = useState({ left: 0, width: 0 });

  useMemo(() => {
    if (!user || !role) {
      return;
    }
    let menu = [
      { id: 1, name: t("Главная"), path: "/" },
      { id: 2, name: t("Мои транзакции"), path: "/transactions" },
      { id: 3, name: t("Вопрос/ответ"), path: "/faq" },
      { id: 4, name: t("Тарифы"), path: "https://zpos.by/dogovor-na-okazanie-servisnykh-uslug" },
      { id: 5, name: t("Контакты"), path: "https://zpos.by/contacts" },
    ];
    setArrayMenu(menu);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, role, hasPreorder]);

  const handleMouseEnter = e => {
    setStyleLeft({ left: e.target.offsetLeft, width: e.target.offsetWidth });
  };

  const menuContent = (
    <>
      {arrayMenu.map(el => {
        const isExternalLink = el.path.startsWith("https://") || el.path.startsWith("http://");
        return (
          <div
            key={el.id}
            className={cls.header_tab}
            onMouseEnter={handleMouseEnter}
            onClick={() => setButtonBurger(false)}>
            {isExternalLink ? (
              <a href={el.path} className={cls.header_tab_all} target="_blank" rel="noopener noreferrer">
                {el.name}
              </a>
            ) : (
              <NavLink
                onClick={() => window.scrollTo({ top: 0 })}
                exact
                className={cls.header_tab_all}
                activeClassName={cls.header_tab_active}
                to={el.path}>
                {el.name}
              </NavLink>
            )}
          </div>
        );
      })}
      <div className={cls.header_tab} onMouseEnter={handleMouseEnter}>
        <NavLink className={cls.header_tab_all_last} to="/" onClick={() => dispatch(authentication.logout())}>
          {t("Выход")}
        </NavLink>
      </div>
    </>
  );

  return (
    <>
      {isAuthorized && (
        <>
          <header className={cls.header_container}>
            <Container component="main" className={cls.container}>
              <div className={cls.header_logo_wrapper}>
                <NavLink to={"/"}>
                  <div className={cls.header_logo_container}></div>
                </NavLink>
                <iframe
                  className={cls.header_banner}
                  src="https://zpos.by/lk_banner.html"
                  title="banner"
                  scrolling="no"
                  frameBorder="0"
                />
              </div>
              <div className={cls.header_button_burger}>
                <div className={cls.menu_wrapper} onClick={() => setButtonBurger(!buttonBurger)}>
                  <HamburgerMenu boolean={buttonBurger} />
                </div>
              </div>
              <div
                onMouseLeave={() => setStyleLeft({ ...styleLeft, width: 0 })}
                className={`${cls.header_tabs_container}`}>
                {menuContent}
                <span className={cls.header_line} style={styleLeft} />
              </div>

              <NavLink
                exact
                className={cls.header_button_settings}
                activeClassName={cls.header_tab_active}
                to="settings">
                <SettingsIcon />
              </NavLink>

              <div className={cls.header_user_info}>
                <div className={cls.header_user_info_org}>
                  <div>{user.orgShortName}</div>
                  <div>УНП {localUnp} </div>
                </div>
                <div className={cls.header_user_info_user}>{user.mainUserPersonName}</div>
              </div>
            </Container>
          </header>

          <div className={cls.menu_conatiner_wrapper}>
            <div id="outer-container">
              <Menu
                outerContainerId={"outer-container"}
                onStateChange={({ isOpen }) => {
                  setButtonBurger(isOpen);
                }}
                right
                isOpen={buttonBurger}
                customBurgerIcon={false}>
                {menuContent}
              </Menu>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Header;
